<template>
  <a
    :href="href"
    class="btn btn-primary btn-sm"
    :class="$style.button"
    @click="emitClick"
  ><slot /></a>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    href: {
      type: String,
      default: undefined,
    },
  },

  methods: {
    /**
     * @fires click
     */
    emitClick(event: Event): void {
      /**
       * @event click
       * @type { Event }
       */
      this.$emit('click', event);
    },
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';
@import '../styles/variables';

.button {
  $color: $page-primary-color;
  --primary-h: #{hue($color)};
  --primary-l: #{lightness($color)};
  --primary-s: #{saturation($color)};
  --primary-yiqav: #{color-yiq($color)};
}
</style>
